const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImpect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "500 400 200 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "horizontal_full_logo",
    "data-name": "horizontal full logo",
    transform: "matrix(0.941778, 0, 0, 1, 184.004852, 405.327271)",
    style: {}
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2031",
    "data-name": "Group 2031",
    transform: "translate(-5464.813 -1454.36)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2030",
    "data-name": "Group 2030"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_418",
    "data-name": "Line 418",
    className: "cls-6",
    y1: 63.492,
    transform: "translate(5834.437 1468.766)",
    style: {
      fill: "none",
      stroke: "rgb(145, 215, 255)",
      strokeMiterlimit: 10,
      strokeWidth: "11.018px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_419",
    "data-name": "Line 419",
    className: "cls-7",
    y1: 63.492,
    transform: "translate(5855.272 1461.297)",
    style: {
      fill: "none",
      stroke: "rgb(157, 228, 198)",
      strokeMiterlimit: 10,
      strokeWidth: "11.018px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_420",
    "data-name": "Line 420",
    className: "cls-8",
    y1: 36.384,
    transform: "translate(5959.446 1485.736)",
    style: {
      fill: "none",
      stroke: "rgb(255, 159, 94)",
      strokeMiterlimit: 10,
      strokeWidth: "11.018px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_421",
    "data-name": "Line 421",
    className: "cls-9",
    y1: 36.384,
    transform: "translate(6001.115 1485.736)",
    style: {
      fill: "none",
      stroke: "rgb(180, 190, 195)",
      strokeMiterlimit: 10,
      strokeWidth: "11.018px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_422",
    "data-name": "Line 422",
    className: "cls-10",
    y1: 47.754,
    transform: "translate(5980.28 1467.43)",
    style: {
      fill: "none",
      stroke: "rgb(255, 229, 95)",
      strokeMiterlimit: 10,
      strokeWidth: "11.018px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_423",
    "data-name": "Line 423",
    className: "cls-11",
    y1: 53.888,
    transform: "translate(5896.941 1473.568)",
    style: {
      fill: "none",
      stroke: "rgb(119, 191, 117)",
      strokeMiterlimit: 10,
      strokeWidth: "11.018px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_424",
    "data-name": "Line 424",
    className: "cls-12",
    y1: 82.699,
    transform: "translate(5917.776 1454.36)",
    style: {
      fill: "none",
      stroke: "rgb(193, 178, 224)",
      strokeMiterlimit: 10,
      strokeWidth: "11.018px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_425",
    "data-name": "Line 425",
    className: "cls-13",
    y1: 29.562,
    transform: "translate(5876.106 1500.137)",
    style: {
      fill: "none",
      stroke: "rgb(199, 227, 88)",
      strokeMiterlimit: 10,
      strokeWidth: "11.018px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_426",
    "data-name": "Line 426",
    className: "cls-14",
    y1: 29.562,
    transform: "translate(5938.611 1501.204)",
    style: {
      fill: "none",
      stroke: "rgb(234, 169, 210)",
      strokeMiterlimit: 10,
      strokeWidth: "11.018px"
    }
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_427",
    "data-name": "Line 427",
    className: "cls-15",
    y1: 29.562,
    transform: "translate(5813.603 1484.664)",
    style: {
      fill: "none",
      stroke: "rgb(110, 171, 246)",
      strokeMiterlimit: 10,
      strokeWidth: "11.018px"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImpect);
export default __webpack_public_path__ + "static/media/impect.6bd05c3d3eaa42569f3665028cbcff93.svg";
export { ForwardRef as ReactComponent };